<template>
  <div class="field">
    <label
      v-if="label"
      class="label"
      :for="inputId"
    >{{ label }}</label>
    <template v-if="buttonText">
      <div class="field has-addons">
        <div class="control">
          <input
            :step="step"
            :id="inputId"
            :value="modelValue"
            @input="parseInput"
            class="input"
            :class="{ 'is-danger': !!error, 'is-small': small }"
            type="number"
            inputmode="decimal"
          />
        </div>
        <div class="control">
          <button
            class="button"
            :class="{ 'is-small': small }"
            @click="emit('buttonClick')"
          >{{ buttonText }}</button>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="control">
        <input
          :step="step"
          :id="inputId"
          :value="modelValue"
          @input="parseInput"
          class="input"
          :class="{ 'is-danger': !!error }"
          type="number"
          inputmode="decimal"
        />
      </div>
    </template>
    <p
      class="help is-danger"
      v-if="error"
    >{{ error[0] }}</p>
  </div>
</template>

<script
  lang="ts"
  setup
>
import { computed } from 'vue';

const props = defineProps<{
  small?: boolean
  modelValue?: string | number | null
  label: string
  error?: string[]
  htmlId?: string
  buttonText?: string
  step?: string
}>()

const inputId = computed(() => {
  if (props.htmlId === undefined) {
    return props.label.replaceAll(" ", "-").toLowerCase()
  } else {
    return props.htmlId
  }
})

const emit = defineEmits<{
  (e: 'update:modelValue', value: string | number): void
  (e: 'buttonClick'): void
}>()

function parseInput(event: InputEvent) {
  const target = event.target as HTMLInputElement
  if (isNaN(parseFloat(target.value))) {
    emit('update:modelValue', target.value)
  } else {
    emit('update:modelValue', parseFloat(target.value))
  }
}

</script>